/**
 * SLAM Sports AI - Default Configuration
 * Generic platform branding with gold color scheme
 */

export const slamConfig = {
  id: 'slam',
  sportCode: 'CBB', // College Baseball - maps to backend sport prompt selection

  branding: {
    name: 'SLAM Sports AI',
    shortName: 'SLAM',
    abbreviation: 'SLAM',
    tagline: 'AI-Powered Sports Analytics',
    organization: 'SLAM Sports AI',
  },

  colors: {
    primary: '#FFD700',           // SLAM Gold
    primaryHover: '#FFC000',      // Darker gold on hover
    secondary: '#1a1a2e',         // Deep navy
    accent: '#FFE55C',            // Light gold accent
    background: '#0a0a0c',        // Near black
    surface: '#141418',           // Dark surface
    surfaceHover: '#1a1a20',      // Surface hover
    border: 'rgba(255, 215, 0, 0.2)', // Gold border
    text: {
      primary: '#ffffff',
      secondary: '#a0a0a0',
      onPrimary: '#000000',       // Black text on gold
    },
    status: {
      success: '#22c55e',
      warning: '#f59e0b',
      error: '#ef4444',
      info: '#3b82f6',
    },
  },

  logos: {
    primary: '/logos/SSAILogo.svg',
    icon: '/logos/SSAILogo.svg',
    alt: 'SLAM Sports AI Logo',
  },

  analysis: {
    systemPromptAdditions: `
You are analyzing video for SLAM Sports AI, a professional sports analytics platform.
Maintain objectivity and provide analysis that could apply to any MLB organization.
Focus on biomechanical patterns, timing signatures, and actionable coaching insights.
`,
    focusAreas: [
      'Biomechanical analysis',
      'Pitch tipping detection',
      'Timing pattern recognition',
      'Pre-release indicators',
      'Coaching recommendations',
    ],
    terminology: {
      platform: 'SLAM Sports AI',
      analyst: 'SLAM Analyst',
      report: 'SLAM Analysis Report',
    },
    defaultLanguage: 'en',
  },

  features: {
    mlbTicker: true,
    agentUniverse: true,
    exports: {
      pdf: true,
      csv: true,
      json: true,
      email: true,
    },
    multilingual: true,
    contextFiles: true,
  },

  contact: {
    website: 'https://slamsports.ai',
    supportEmail: 'support@slamsports.ai',
  },

  meta: {
    version: '1.0.0',
    createdAt: '2024-12-17',
    updatedAt: '2024-12-17',
  },
};

export default slamConfig;
